function zoom(e) {
  var zoomer = e.currentTarget;
  var offsetX, offsetY;

  if (e.type === 'mousemove') {
    offsetX = e.offsetX;
    offsetY = e.offsetY;
  } else if (e.type === 'touchmove') {
    var touch = e.touches[0];
    offsetX = touch.pageX - $(zoomer).offset().left;
    offsetY = touch.pageY - $(zoomer).offset().top;
  }

  var x = (offsetX / zoomer.offsetWidth) * 100;
  var y = (offsetY / zoomer.offsetHeight) * 100;
  zoomer.style.backgroundPosition = x + '% ' + y + '%';
}

$('.product__photo.main_image').on('click', function(e) {
  $(this).toggleClass('zoom_apply');
  if ($(this).hasClass("zoom_apply")) {
    $(this).find('figure').addClass('zoom');
    $(this).find('figure').on('mousemove touchmove', zoom);
    var image = $(this).find('figure img').attr('src');
    $(this).find('figure').css({
      "background-image": "url('" + image + "')",
      "background-size": "150%" // Set background size to 150%
    });
  } else {
    $(this).find('figure').removeClass('zoom');
    $(this).find('figure').off('mousemove touchmove', zoom);
  }
});
